var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1975 10.4481L14.1673 13.4144L13.4135 14.1673L10.4428 11.2001C9.42701 12.044 8.12133 12.5515 6.69706 12.5515C3.45897 12.5515 0.833984 9.92843 0.833984 6.69273C0.833984 3.45704 3.45897 0.833984 6.69706 0.833984C9.93514 0.833984 12.5601 3.45704 12.5601 6.69273C12.5601 8.12173 12.0482 9.43124 11.1975 10.4481ZM6.69706 11.4863C9.34641 11.4863 11.4941 9.34013 11.4941 6.69273C11.4941 4.04534 9.34641 1.89922 6.69706 1.89922C4.04772 1.89922 1.90001 4.04534 1.90001 6.69273C1.90001 9.34013 4.04772 11.4863 6.69706 11.4863Z",
    fill: "#FF0083"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon_search.d58c33e81387a14fbe6cd103a7d08239.svg";
export { ForwardRef as ReactComponent };